import { TestimonialPopup } from './TestimonialPopup';

export class TestimonialFilters {
    constructor({filtersContainer, testimonialsContainer}) {
        this.filtersContainer = filtersContainer;
        this.testimonialsContainer = testimonialsContainer;
        this.apiUrl = window.testimonialData.filterTestimonialsApiRoute;
        this.currentUrl = window.location.origin + window.location.pathname;
        this.urlParams = new URLSearchParams(window.location.search);
        this.filterList = this.urlParams.getAll('categories[]');
        this.currentPage = 1;
        this.scrolledToBottom = false;
        const { playButtonSmall, checkmark, loading } = window.testimonialsPageIcons;
        this.playButtonSmall = playButtonSmall;
        this.checkmark = checkmark;
        this.loading = loading;
        this.init();
        window.testimonialFilter = this;
    };

    init() {
        window.onpopstate = () => {
            location.reload();
        };

        $(this.filtersContainer).on('click', '.input', (event) => {
            this.currentPage = 1;
            if (event.currentTarget.checked) {
                this.filterList.push($(event.currentTarget).val());
                this.handleDataChange(this.filterList);
            } else {
                this.filterList.splice(this.filterList.indexOf($(event.currentTarget).val()), 1);
                this.handleDataChange(this.filterList);
            }
        });

        $(this.testimonialsContainer).on('click', '.play-button', (event) => {
            const testimonialId = $(event.currentTarget).data('testimonial-id');
            const questionId = $(event.currentTarget).data('question-id');
            new TestimonialPopup({testimonialId: testimonialId, questionId: questionId, showViewAllButton: false}).openPopup();
        });

        $(this.testimonialsContainer).on('click', '.testimonial.multiple .tags .tag', (event) => {
            const id = $(event.currentTarget).data('id').toString()
            this.handleTagClick(id);
        });

        $(window).on('scroll', () => {
            if ($('.loading').exists()) {
                if ($('.loading').position().top - $(window).height() <= ($(window).scrollTop() + 200) && !this.scrolledToBottom) {
                    this.currentPage += 1;
                    this.handleDataChange(this.filterList, this.currentPage, true);
                    this.scrolledToBottom = true;
                }
            }
        });
    };

    async filterFunction(filterList, page = 1, infiniteScroll = false) {
        const axiosOptions = {
            params: {
                json: true,
                categories: filterList,
                page: page
            }
        };

        try {
            const response = await axios.get(this.apiUrl, axiosOptions);

            /* Updating URL */
            const url = axios.getUri({
                url: this.currentUrl,
                params: {
                    categories: filterList
                }
            });
            if (!infiniteScroll) {
                const values = Object.values(response.data.data.meta)
                window.history.pushState(values, '', url);
            }
            
            return response.data;
        } catch (error) {
            console.log(error);
        }
    };

    handleDataChange(filterList, page = 1, infiniteScroll = false) {
        if (!infiniteScroll) {
            $(this.testimonialsContainer).addClass('loading')
        }

        this.filterFunction(filterList, page, infiniteScroll).then(data => {
            $(this.testimonialsContainer).removeClass('loading')

            if (!infiniteScroll) {
                $(this.filtersContainer).empty();
                $(this.testimonialsContainer).empty()
                Object.values(data.data.categories).forEach(category => {
                    $(this.filtersContainer).append(this.filterTemplate(category));
                });
            } else {
                $(this.testimonialsContainer).find('.loading').remove();
                this.scrolledToBottom = false;
            }

            data.data.testimonials.forEach(testimonial => {
                $(this.testimonialsContainer).append(this.testimonialsTemplate(testimonial));
            });

            if ($('.testimonial.multiple').length < data.data.meta.total) {
                $(this.testimonialsContainer).append(this.loadingTemplate());
            }
        }).catch(error => {
            console.log(error);
        });
    };

    testimonialsTemplate({id, author, categories, duration, question, thumbnail}) {
        return `
            <div class="testimonial multiple">
                <div class="preview">
                    <img class="preview-image" src="${thumbnail}"/>
                    <div class="duration">${this.secondsToMinutes(duration)}</div>
                    <div class="play">
                        <button class="play-button" data-testimonial-id=${id} data-question-id=${question.id}>
                            ${this.playButtonSmall}
                        </button>
                    </div>
                    <div class="question">${question.question}</div>
                </div>
                <div class="person-info">
                    <img class="person-image" src="${author.avatar}" />
                    <div class="name">${author.name}</div>
                    <div class="position">${author.position}</div>
                </div>
                <div class="tags">
                    ${categories.map((current) => {
                        return `<a class="tag" data-id="${current.id}">${current.category}</a>`
                    }).join('')}
                </div>
            </div>
        `;
    };

    filterTemplate({categories, name}/*{name, id}*/) {
        return `
            <p>${name}</p>
            ${categories.map(category => {
                return `
                    <label class="checkbox">
                        <span class="checkbox-input">
                            <input class="input" type="checkbox" 
                                name="${category.name.toLowerCase()}" 
                                id="${category.name.toLowerCase()}" 
                                value="${category.id}" 
                                ${this.filterList.includes(category.id.toString()) ? "checked" : ""}/>
                            <span class="checkbox-control">
                                ${this.checkmark}
                            </span>
                        </span>
                        <span class="radio-label">${category.name}</span>
                    </label>
                `
            }).join('')}
        `
    };

    loadingTemplate() {
        return `<div class="loading">${this.loading}</div>`;
    };

    secondsToMinutes(seconds) {
        seconds = Number(seconds);
        const m = Math.floor(seconds % 3600 / 60);
        const s = Math.floor(seconds % 3600 % 60);

        return ('' + m).slice(-2) + ':' + ('0' + s).slice(-2);
    };

    handleTagClick(categoryId) {
        if (!this.filterList.includes(categoryId)) {
            this.filterList.push(categoryId);
            this.handleDataChange(this.filterList);
        }
    };

};